<template>
    <!--    <div class="fullscreen_btn" style="color:#fffff0;font-size:12px;" @click="changeFullScreen">-->
    <div class="fullscreen_btn" style="color:#fffff0;font-size:12px;margin-left:10px" @click="changeFullScreen">
        <el-tooltip placement="right">
            <i class="el-icon-full-screen"></i>
            <div slot="content">
                {{fullStr}}
            </div>
        </el-tooltip>
    </div>


    <!--    </div>-->
</template>

<script>

    export default {
        name: "FullScreenButton",
        props: {
            divId: {
                type: String
            }
        },
        data() {


            return {
                fullStr: '全屏',
                // 是否全屏
                isFullScreen: document.fullscreenElement,
            };
        },
        mounted() {
            window.addEventListener("keydown", this.keyDown, true); // 监听按键事件
            window.addEventListener("resize", this.changeIsFullScreen);
            window.addEventListener("fullscreenchange", this.changeIsFullScreen);
        },
        beforeDestroy() {
            window.removeEventListener("keydown", this.keyDown);
            window.removeEventListener("resize", this.changeIsFullScreen);
            window.removeEventListener("fullscreenchange", this.changeIsFullScreen);
        },
        methods: {
            changeIsFullScreen() {

                this.isFullScreen = document.fullscreenElement;
                this.fullStr = this.isFullScreen?'退出':'全屏';

            },
            keyDown(event) {
                event = event || window.event;
                // console.log(event.keyCode);
                if (event.keyCode === 122) {
                    // 禁用f11
                    // event.returnValue = false;
                    event.preventDefault();
                    this.changeFullScreen();
                }
            },
            changeFullScreen(id = "") {

                id = this.divId.toString();

                let element = id ? document.getElementById(id) : document.documentElement; // 全屏元素
                element = document.getElementById('fullDiv');

                if (document.fullscreenElement) {
                    // 退出全屏
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        // 兼容火狐
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        // 兼容谷歌等
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        // 兼容IE
                        document.msExitFullscreen();
                    }

                } else {


                    // 进入全屏
                    if (element.requestFullscreen) {

                        element.requestFullscreen();
                    } else if (element.mozRequestFullScreen) {
                        // 兼容火狐

                        element.mozRequestFullScreen();
                    } else if (element.webkitRequestFullscreen) {

                        // 兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
                        element.webkitRequestFullscreen();
                    } else if (element.msRequestFullscreen) {
                        // 兼容IE,只能写msRequestFullscreen

                        element.msRequestFullscreen();
                    }

                }
                //this.$emit("reDrawChart");

            },
        },
    };
</script>



